import React from "react";
import { HorizontalTile, TileData } from "./HorizontalTile";

interface TilesListProps {
  tiles: TileData[];
  onLearnMore: (tileData: TileData) => void;
}

export const TilesList: React.FC<TilesListProps> = ({ tiles, onLearnMore }) => (
  <div className="whats-new-tiles">
    <div className="whats-new-titles-container !w-[90%]">
        <h2
          className="whats-new-version-title !text-6xl text-center w-full !font-medium"
          style={{ color: "#004578" }}
        >
          Innovation in Motion
        </h2>
        <div className="leading-[30px] text-[18px] sm:text-[20px] lg:text-[22px] xl:text-[24px] text-[#474F56] font-[300] mb-6 sm:mb-8 lg:mb-10 xl:mb-12 flex justify-center text-center"  
            style={{ textAlign: 'justify', textJustify: 'inter-word' }}
        >
          We are pleased to introduce the new version of our website, designed
          to offer a more efficient, clear, and accessible experience for all
          our users. This updates reflects our ongoing commitment to staying at
          the forefront, incorporating improvements that address current needs
          and facilitate interaction with our content and services.
        </div>
      </div>
    {tiles.map((tile, index) => (
      <HorizontalTile
        key={index}
        title={tile.title}
        text={tile.text}
        image={tile.image}
        imageStyle={tile.imageStyle}
        onLearnMore={onLearnMore}
        tileStyles={{marginBottom: 24, width: "90%"}}
        fullText={tile.fullText}
        actionButton={tile.actionButton}
      />
    ))}
  </div>
);
